import API from '@/services/api';

export default {
  namespaced: true,
  state: {
    background: {
      type: '',
      url: '',
    },
    content: '',
    media: [],
  },
  mutations: {
    ['main:set'](state, { background, content }) {
      state.background = { ...background };
      state.content = content;
    },
    ['mainMediaContent:set'](state, media) {
      state.media = media.data;
    },
  },
  actions: {
    async ['main:fetch']({ commit }) {
      try {
        const pageContent = await API.getMainPageContent();
        commit('main:set', pageContent);
      } catch (err) {
        console.error(err);
      }
    },
    async ['mainMediaContent:fetch']({ commit }) {
      try {
        const pageMediaContent = await API.getMainPageMedia();
        commit('mainMediaContent:set', pageMediaContent);
      } catch (err) {
        console.error(err);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pages/main/index.js